<template>
    <div class="components-container" id="mobileViewPort">
        <div id="mobileMode">
            <div id="titleArea">
                <div class="titleText">选修选课</div>
                <div class="titleButton">
                    <el-button class="custom-el-button" type="primary" @click="showHomePage">
                        <i class="el-icon-s-home"></i> 首页
                    </el-button>
                </div>
            </div>
            <div id="queryArea">
                <div class="filter-container">
                    <div class="formItem text-center">
                        <el-button @click="personalInfo" type="success" style="margin-left: 0px"><i class="el-icon-document-copy"></i>&nbsp;个人报名信息</el-button>
                    </div>
                </div>
            </div>

            <!-- 搜索内容弹框 -->
            <!-- <el-dialog id="queryDialog" class="formDialog" title="查询信息" width="90%" :visible.sync="queryDialogVisible">
                <el-row v-if="teaAuthVisible">
                    <el-input v-model="queryForm.stuCode" placeholder="学号 / 姓名" clearable></el-input>
                </el-row>
                <el-row>
                    <el-input v-model="queryForm.courseName" placeholder="原 / 现课程名称" clearable></el-input>
                </el-row>
                <el-row>
                    <el-select v-model="queryForm.auditState" placeholder="审核状态" clearable>
                        <el-option v-for="(item, index) in comboOption.auditState" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                        </el-option>
                    </el-select>
                </el-row>
                <div slot="footer" class="dialog-footer text-center">
                    <el-button type="gray" @click="handleFilter">查 询</el-button>
                    <el-button style="margin-left: 10px;" type="gray" @click="handleReset">重 置</el-button>
                    <el-button style="margin-left: 10px;" @click="queryDialogVisible = false">取 消</el-button>
                </div>
            </el-dialog> -->

            <div id="listArea" @scroll="handleScroll">
                <div v-if="tableData==null || tableData.length==0" class="cardTips">没有选课信息</div>
                <div class="cardMain" v-for="(item,index) in tableData" :key="index">
                    <div class="cardText">
                        <p><label for="">学年学期：</label>{{ item.xnxqmc }}</p>
                        <p><label for="">课程类型：</label>{{ item.courseTypeName }}</p>
                        <p><label for="">选修班名称：</label>{{ item.electiveClassName }}</p>
                        <p><label for="">报名人数：</label>{{ item.studentNumber }}</p>
                        <p><label for="">限额人数：</label>{{ item.quotaNumber }}</p>
                        <div class="auditStateImg">
                            <img v-if="item.selectCourse=='1'" :src="loadStateImg(item)" alt="">
                        </div>
                    </div>
                    <div class="cardInput" >
                        <el-button v-if="item.selectCourse!='1'" type="primary" @click="showDetailInfo(item, 'sel')">选课</el-button>
                        <el-button v-else type="primary" @click="showDetailInfo(item, 'show')">详情</el-button>
                    </div>
                </div>
                <div v-if="total>2 && total>tableData.length" id="loadingTips">
                    <i class="el-icon-loading"></i>&nbsp;信息加载中，请稍候...
                </div>
            </div>

            <el-dialog id="mainDialog" class="formDialog" :title="dialogTitle" :visible.sync="dialogVisible" @closed="closeDialog" width="90%">
                <el-scrollbar id="mainDialogScroll" ref="mainDialogScroll">
                    <el-form ref="applyForm" :model="applyForm" label-width="84px" label-position="left" width="100%">
                        <el-form-item label="学年学期" prop="xnxqbm">
                            {{ applyForm.xnxqbm }}
                        </el-form-item>

                        <el-form-item label="选修班名称" prop="electiveClassName">
                            {{ applyForm.electiveClassName }}
                        </el-form-item>

                        <!-- <el-form-item label="课程类型" prop="courseType">
                            {{ applyForm.courseTypeName }}
                        </el-form-item> -->

                        <el-form-item label="限额人数" prop="quotaNumber">
                            {{ applyForm.quotaNumber }}
                        </el-form-item>

                        <el-form-item label="授课周次" prop="teachingWeek">
                            {{ applyForm.teachingWeek }}
                        </el-form-item>

                        <el-form-item label="上课时间" prop="sjxl">
                            {{ applyForm.sjxl }}
                        </el-form-item>

                        <el-form-item label="任课教师" prop="teacherName">
                            {{ applyForm.teacherName }}
                        </el-form-item>

                        <el-form-item label="场地名称" prop="siteName">
                            {{ applyForm.siteName }}
                        </el-form-item>

                        <el-form-item label="学分" prop="credit">
                            {{ applyForm.credit }}
                        </el-form-item>

                        <el-form-item label="总课时" prop="totalClassHours">
                            {{ applyForm.totalClassHours }}
                        </el-form-item>


                        <!-- <el-form-item label="考试形式" prop="examinationForm">
                            {{ applyForm.examinationForm }}
                        </el-form-item> -->

                        <el-form-item label="备注" prop="remarks">
                            {{ applyForm.remarks }}
                        </el-form-item>
                    </el-form>
                </el-scrollbar>

                <div v-if="operateButtonVisible" slot="footer" class="dialog-footer text-center">
                    <el-button @click="selectCourse" :disabled="disabled" type="success">选课</el-button>
                    <el-button @click="closeDialog" type="danger" style="margin-left: 10px">取消</el-button>
                </div>
            </el-dialog>

            <el-dialog id="personInfoDialog" class="formDialog" title="个人选课信息" :visible.sync="personalInfoDialogVisible"
                v-if="personalInfoDialogVisible" width="90%" top="-20px">
                <personInfo ref="personInfo" :isDivideTab="0" :listHeight="450" @closePersonInfoDialog="closePersonInfoDialog"></personInfo>
            </el-dialog>

        </div>
    </div>
</template>
<script>
    import { confirmMsg, showNotify } from "utils/message";
    import personInfo from './personInfo.vue';

    export default {
        components:{
            personInfo,
        },
        data() {
            return {
                queryForm: {
                    pageNum: 1,
                    rowNum: 10,
                    xnxqbm: null,
                    electiveDetailCode: null,
                    courseType: "",
                    courseName: null,
                    state: null,
                    //isDivideTab: "0",//不是体育选修课
                },
                personForm: {
                    pageNum: 1,
                    rowNum: 10,
                    xnxqbm: null,
                    electiveDetailCode: null,
                    courseType: "",
                    courseName: null,
                    state: null,
                    //isDivideTab: "0",//不是体育选修课
                },
                xnxqInfo: [], //学年学期下拉框
                courseTypeInfo: [], //课程类型下拉框
                courseInfo: [], //课程下拉框
                classWeekInfo: [], //上课日期下拉框
                classTimeInfo: [], //上课时间下拉框
                examinationFormInfo: [], //考试形式下拉框
                registrableDeptInfo: [], //可报名系部下拉框
                registrableMajorInfo: [], //可报名专业下拉框
                registrableClassInfo: [], //可报名班级下拉框
                registrableGradeInfo: [], //可报名年级下拉框
                registrableRecruitNatureInfo: [], //可报名层次类型下拉框
                isDivideInfo: [],//是否分班教育选修课下拉框
                stateInfo: [],//状态下拉框
                majorInfo: [],//专业下拉框
                gradeInfo: [],//年级下拉框
                tableData: [],
                currentXnxq: null,//当前学期
                checkSelection: false,//是否在选课时间范围内
                currentPage: 1,
                limit: 10,
                total: null,
                tableLoading: true,
                selectRowData: null,
                mainTableHeight: 500,
                dialogTitle: "",
                dialogVisible: false,
                formSubmiting: false,
                editType: null,
                stuInfo:null,
                disabled: false,

                limit_personalInfo : 10,
                currentPage_personalInfo: 1,
                personalInfoData: [],
                personalInfoTableHeight: 500,
                personalInfoDialogVisible: false,
                topHeight: 0+'px',
                errorDialogVisible: false,
                errorMessage: '',

                applyForm: {
                    xnxqbm: '',
                    electiveClassName: '',
                    courseTypeName: '',
                    quotaNumber: null,
                    teachingWeek: '',
                    classWeek: '',
                    classTime: '',
                    teacherName: '',
                    siteName: '',
                    credit: null,
                    totalClassHours: null,
                    examinationForm: null,
                    remarks: null,
                },

                operateButtonVisible: true,
                weekall: null,
            };
        },
        created() {
            this.initParam();
        },
        mounted() {

        },
        methods: {
            showHomePage(){
                this.$router.push('/m/wx/home');
            },
            initParam(){
                this.initOption();

                //判断是否在选课时间范围内
                const paramMap = {
                    'courseType': ''
                }
                this.$api.electiveManage.studentSelection.checkSelectTime({
                    data: paramMap
                }).then(response => {
                    this.currentXnxq = response.data.data.xnxqbm;
                    this.checkSelection = response.data.data.result;
                    if(this.checkSelection == "true"){
                        this.queryList();
                    }else{
                        this.$alert('当前时间未开放选课', '提示', {
                            confirmButtonText: '确定',
                            customClass: 'el-message-box-mobile',
                            callback: action => {}
                        });
                        this.tableLoading = false;
                    }

                }).catch(error => {
                    console.log(error);
                });
            },
            initOption(){
                const paramMap = {
                    'name': 'combo_Info'
                }
                this.$api.electiveManage.studentSelection.initOption({
                    data: paramMap
                }).then(response => {
                    this.courseTypeInfo = response.data.data.courseType;
                }).catch(error => {
                    console.log(error);
                });
            },
            queryList() {
                if(this.checkSelection == "true"){
                    this.tableLoading = true;
                    this.queryForm.pageNum = this.currentPage;
                    this.queryForm.rowNum = this.limit;
                    this.queryForm.xnxqbm = this.currentXnxq;

                    this.$api.electiveManage.studentSelection.list({
                        data: this.queryForm,
                    }).then((response) => {
                        this.total = response.data.data.total;
                        this.tableData = this.tableData.concat(response.data.data.list);
                        this.weekall = response.data.data.weekall;
                        this.tableLoading = false;
                    }).catch((error) => {
                        this.tableLoading = false;
                        console.log(error);
                    });
                }
            },
            requeryList() {
                this.scrollToTop();
                this.tableData.length = 0;
                this.currentPage = 1;
                this.queryList();
            },
            loadStateImg(row){
                if(row.selectCourse==='1'){
                    //已选课
                    return require('image/mobile/auditState/ybm.png');
                }
            },
            handleScroll(){
                if(this.checkVisible() && !this.tableLoading && this.total>this.tableData.length){
                    this.currentPage++;
                    this.queryList();
                }
            },
            checkVisible() {
                const ele = document.getElementById('loadingTips');
                if(ele){
                    let rect = ele.getBoundingClientRect();
                    //获取当前浏览器的视口高度，不包括工具栏和滚动条
                    //document.documentElement.clientHeight兼容 Internet Explorer 8、7、6、5
                    let viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
                    //bottom top是相对于视口的左上角位置
                    //bottom大于0或者top-视口高度小于0可见
                    return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
                }else{
                    return false;
                }
            },
            scrollToTop(){
                const ele = document.getElementById('listArea');
                if(ele){
                    ele.scrollTop = 0;
                }
            },
            showDetailInfo(rowData, type){
                this.selectRowData = rowData;
                this.dialogTitle = '详情';
                if(type == 'sel'){
                    this.operateButtonVisible = true;
                    this.setMainDialogStyle('-50px', '78vh');
                }else{
                    this.operateButtonVisible = false;
                    this.setMainDialogStyle('-50px', '85vh');
                }
                this.dialogVisible = true;
                this.fieldVisible = false;
                this.fillForm();
            },
            fillForm(){
                this.$nextTick(() => {
                    this.applyForm.xnxqbm = this.selectRowData.xnxqbm;
                    this.applyForm.electiveClassName = this.selectRowData.electiveClassName;
                    this.applyForm.courseTypeName = this.selectRowData.courseTypeName;
                    this.applyForm.quotaNumber = this.selectRowData.quotaNumber;
                    this.applyForm.teachingWeek = this.selectRowData.teachingWeek;
                    this.applyForm.sjxl = this.timeSeriesFormatter(this.selectRowData);
                    this.applyForm.teacherName = this.selectRowData.teacherName;
                    this.applyForm.siteName = this.selectRowData.siteName;
                    this.applyForm.credit = this.selectRowData.credit;
                    this.applyForm.totalClassHours = this.selectRowData.totalClassHours;
                    this.applyForm.examinationForm = this.selectRowData.examinationForm;
                    this.applyForm.remarks = this.selectRowData.remarks;
                });

                this.restoreScroll();
            },
            setMainDialogStyle(top, height){
                document.getElementById('mainDialog').style.top = top;
                this.$nextTick(() => {
                    document.getElementById('mainDialogScroll').style.height = height;
                });
            },
            restoreScroll(){
                this.$nextTick(() => {
                    this.$refs.mainDialogScroll.wrap.scrollTop = 0;
                });
            },
            closeDialog() {
                this.dialogVisible = false;

                if(this.$refs['applyForm'] !== undefined){
                    this.$refs['applyForm'].resetFields();
                }

            },
            rowClick(row) {
                this.selectRowData = row;
            },
            selectCourse(){
                if (this.selectRowData == null) {
                    this.$message({
                        title: '提示',
                        message: '请选择选修班！',
                        type: 'warning',
                        duration: 2000,
                    });
                    return;
                }
                confirmMsg('是否确定选择这门选修课？', 'el-message-box-mobile').then(() => {
                    this.disabled = true;
                    const paramMap = {
                        'pageNum': this.currentPage,
                        'rowNum': this.limit,
                        'xnxqbm': this.currentXnxq,
                        'electiveDetailCode': this.selectRowData.electiveDetailCode,
                        'courseType': this.selectRowData.courseType,
                        'isDivideTab': '0',
                    }
                    this.$api.electiveManage.studentSelection.studentSelection({
                        data: paramMap
                    }).then(response => {
                        let state = response.data.data.state;
                        let msg = response.data.data.msg;
                        this.disabled = false;
                        if (state == 'Success') {
                            this.$notify({
                                title: "成功",
                                message: msg ? msg : "保存成功",
                                type: "success",
                                duration: 1500,
                            });

                            this.requeryList();
                            this.selectRowData = null;
                            this.dialogVisible = false;
                        }else{
                            this.$alert(msg, '提示', {
                                confirmButtonText: '确定',
                                customClass: 'el-message-box-mobile',
                                callback: action => {}
                            });
                        }
                    }).catch(error => {
                        console.log(error);
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消选择'
                    });
                });
            },
            handlePageChange(val) {
                this.currentPage = val;
                this.requeryList();
            },
            handleCurrentChange(val) {
               this.selectRowData = val;
            },
            handleSizeChange(val) {
                this.limit = val;
                this.currentPage = 1;
                this.requeryList();
            },
            closeErrorDialog() {
                this.errorMessage = '';
                this.errorDialogVisible = false;
            },
            personalInfo(){
                this.queryStuSelection();
                this.personalInfoDialogVisible = true;
                this.$nextTick(() => {
                    document.getElementById('personInfoDialog').style.top = '-25px';
                });
            },
            //查询学生所有选课信息
            queryStuSelection() {
                this.tableLoading = true;
                this.personForm.pageNum = this.currentPage_personalInfo;
                this.personForm.rowNum = this.limit_personalInfo;
                this.personForm.xnxqbm = this.currentXnxq;

                this.$api.electiveManage.studentSelection.queryStuSelection({
                    data: this.personForm,
                }).then((response) => {
                    this.personalInfoData = response.data.data.list;
                    this.tableLoading = false;
                }).catch((error) => {
                    this.tableLoading = false;
                    console.log(error);
                });
            },
            changeCourseType(){
                this.queryStuSelection();
            },
            delSelection(row){
                const paramMap = {
                    'xnxqbm': this.currentXnxq,
                    'electiveDetailCode': row.electiveDetailCode,
                    'studentCode': row.studentCode,
                    'isDivideTab': '0',
                };
                confirmMsg('是否确认删除该选课信息？', 'el-message-box-mobile').then(() => {
                    this.$api.electiveManage.studentSelection.delSelection({
                        data: paramMap
                    }).then(response => {
                        let state = response.data.data.state;
                        let msg = response.data.data.msg;

                        if (state == 'Success') {
                            this.$notify({
                                title: "成功",
                                message: msg ? msg : "删除成功",
                                type: "success",
                                duration: 1500,
                            });
                            this.queryStuSelection();
                            this.requeryList();
                        }else{
                            this.$notify({
                                title: "失败",
                                message: msg ? msg : '删除失败',
                                type: "error",
                                duration: 3000,
                            });
                        }
                    }).catch(error => {
                        this.formSubmiting = false;
                        this.$notify({
                            title: '错误',
                            message: error, /// l..
                            type: 'error',
                            duration: 3000,
                        });
                        console.log(error);
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            closePersonInfoDialog(){
                this.requeryList();
            },
            // more(){
            //     if(this.hideQueryArea == false){
            //         this.mainTableHeight = window.innerHeight - this.$refs.mainTable.$el.offsetTop - 205;
            //         this.$nextTick(function () {
            //             this.hideQueryArea = true;
            //         });
            //     }else{
            //         this.mainTableHeight = window.innerHeight - this.$refs.mainTable.$el.offsetTop - 85;
            //         this.$nextTick(function () {
            //             this.hideQueryArea = false;
            //         });
            //     }
            // },
            //失去焦点直接获取输入的单位名称
            unitblur(e, item, index){
                if(e.target.value != ''){
                    this.editForm.internshipUnitId = e.target.value;
                }
            },
            getCurrentFormatDate(){
                var date = new Date();
                var seperator1 = "-";
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var strDate = date.getDate();
                if (month >= 1 && month <= 9) {
                    month = "0" + month;
                }
                if (strDate >= 0 && strDate <= 9) {
                    strDate = "0" + strDate;
                }
                var currentdate = year + seperator1 + month + seperator1 + strDate;
                return currentdate;
            },
            timeSeriesFormatter(row){
                if(row.timeSeries==""||row.timeSeries==undefined){
                    return "";
                }
                if(row.timeSeries.indexOf(";")>-1 || row.timeSeries.indexOf("{")>-1){
                    return row.timeSeries;
                }else{
                    let result = "";

                    let timeSeries = row.timeSeries.split(",");
                    let skxq = timeSeries[0].substring(0,2);
                    let sksj = timeSeries[0].substring(0,2) + timeSeries[0].substring(2,4)+",";
                    if(timeSeries.length==1){
                        sksj = sksj.substring(0, sksj.length-1);
                        result += this.dayFormatter(sksj,row)+"；";
                    }else{
                        for(let j=1;j<timeSeries.length;j++){
                            if(timeSeries[j].substring(0,2) == skxq){
                                sksj += timeSeries[j].substring(0,2) + timeSeries[j].substring(2,4)+",";
                                if(j == timeSeries.length-1){//最后一项
                                    sksj = sksj.substring(0, sksj.length-1);
                                    result += this.dayFormatter(sksj,row)+"；";
                                }
                            }else{
                                //不相同
                                sksj = sksj.substring(0, sksj.length-1);
                                result += this.dayFormatter(sksj,row)+"；";
                                //最后一项
                                skxq = timeSeries[j].substring(0,2);
                                sksj = timeSeries[j].substring(0,2) + timeSeries[j].substring(2,4)+",";
                                if(j == timeSeries.length-1 && timeSeries[j-1].substring(0,2) != timeSeries[j].substring(0,2)){
                                    sksj = sksj.substring(0, sksj.length-1);
                                    result += this.dayFormatter(sksj,row)+"；";
                                }
                            }
                        }
                    }
                    return result;
                }
            },
            dayFormatter(sksj,row){
                let sw = parseInt(row.sw,10);
                let zw = parseInt(row.zw,10);
                let xw = parseInt(row.xw,10);
                let ws = parseInt(row.ws,10);

                var sksj2 = sksj.split(",");
                var week = sksj2[0].substring(0,2);
                if(week=="01"){
                    week="周一";
                }else if(week=="02"){
                    week="周二";
                }else if(week=="03"){
                    week="周三";
                }else if(week=="04"){
                    week="周四";
                }else if(week=="05"){
                    week="周五";
                }else if(week=="06"){
                    week="周六";
                }else if(week=="07"){
                    week="周日";
                }

                var apm="";
                var num="";
                var lxsw="-1";
                var lxzw="-1";
                var lxxw="-1";
                var lxws="-1";
                var jcsw=-1;
                var jczw=-1;
                var jcxw=-1;
                var jcws=-1;
                var jczws=-1;
                var jcxws=-1;
                var jcwss=-1;
                //判断连续
                for(var i=0;i<sksj2.length;i++){
                    var apm=parseInt(sksj2[i].substring(2,4),10);
                    if(apm<=sw){//上午
                        jcsw=i;
                        if(i>0 && lxsw!="0"){
                            if(parseInt(sksj2[i].substring(2,4),10)-parseInt(sksj2[i-1].substring(2,4),10)==1 ){
                                lxsw="1";
                            }else{
                                lxsw="0";
                            }
                        }
                    }
                }
                if(jcsw!=-1){
                    jczws=jcsw+1;
                }else{
                    jczws=0;
                }
                for(var i=0;i<sksj2.length;i++){
                    var apm=parseInt(sksj2[i].substring(2,4),10);
                    if(apm>sw&&apm<=(sw+zw)){//中午
                        jczw=i;
                        if(i>0 && lxzw!="0"){
                            if(parseInt(sksj2[i-1].substring(2,4),10)>sw){
                                if(parseInt(sksj2[i].substring(2,4),10)-parseInt(sksj2[i-1].substring(2,4),10)==1 && parseInt(sksj2[i-1].substring(2,4),10)>sw ){
                                    lxzw="1";
                                }else{
                                    lxzw="0";
                                }
                            }
                        }
                    }
                }
                if(jczw!=-1){
                    jcxws=jczw+1;
                }else{
                    if(jcsw!=-1){
                        jcxws=jcsw+1;
                    }else{
                        jcxws=0;
                    }
                }
                for(var i=0;i<sksj2.length;i++){
                    var apm=parseInt(sksj2[i].substring(2,4),10);
                    if(apm>(sw+zw)&&apm<=(sw+zw+xw)){//下午
                        jcxw=i;
                        if(i>0 && lxxw!="0"){
                            if(parseInt(sksj2[i-1].substring(2,4),10)>(sw+zw)){
                                if(parseInt(sksj2[i].substring(2,4),10)-parseInt(sksj2[i-1].substring(2,4),10)==1){
                                    lxxw="1";
                                }else{
                                    lxxw="0";
                                }
                            }
                        }
                    }
                }
                if(jcxw!=-1){
                    jcwss=jcxw+1;
                }else{
                    if(jczw!=-1){
                        jcwss=jczw+1;
                    }else{
                        if(jcsw!=-1){
                            jcwss=jcsw+1;
                        }else{
                            jcwss=0;
                        }
                    }
                }
                for(var i=0;i<sksj2.length;i++){
                    var apm=parseInt(sksj2[i].substring(2,4),10);
                    if(apm>(sw+zw+xw)){//晚上
                        jcws=i;
                        if(i>0 && lxws!="0"){
                            if(parseInt(sksj2[i-1].substring(2,4),10)>(sw+zw+xw)){
                                if(parseInt(sksj2[i].substring(2,4),10)-parseInt(sksj2[i-1].substring(2,4),10)==1){
                                    lxws="1";
                                }else{
                                    lxws="0";
                                }
                            }
                        }
                    }
                }

                if(lxsw=="1"){
                    num+="上午第"+parseInt(sksj2[0].substring(2,4),10)+"-"+parseInt(sksj2[jcsw].substring(2,4),10)+",";
                }else{
                    for(var i=0;i<=jcsw;i++){
                        num+="上午第"+parseInt(sksj2[i].substring(2,4),10)+",";
                    }
                }
                if(lxzw=="1"){
                    num+="中午第"+(parseInt(sksj2[jczws].substring(2,4),10)-sw)+"-"+(parseInt(sksj2[jczw].substring(2,4),10)-sw)+",";
                }else{
                    for(var i=jcsw+1;i<=jczw;i++){
                        num+="中午第"+(parseInt(sksj2[i].substring(2,4),10)-sw)+",";
                    }
                }
                if(lxxw=="1"){
                    num+="下午第"+(parseInt(sksj2[jcxws].substring(2,4),10)-sw-zw)+"-"+(parseInt(sksj2[jcxw].substring(2,4),10)-sw-zw)+",";
                }else{
                    var st=-1;
                    if(jczw==-1){
                        st=jcsw;
                    }else{
                        st=jczw;
                    }
                    for(var i=st+1;i<=jcxw;i++){
                        num+="下午第"+(parseInt(sksj2[i].substring(2,4),10)-sw-zw)+",";
                    }
                }
                if(lxws=="1"){
                    num+="晚上第"+(parseInt(sksj2[jcwss].substring(2,4),10)-sw-zw-xw)+"-"+(parseInt(sksj2[jcws].substring(2,4),10)-sw-zw-xw)+",";
                }else{
                    var st=-1;
                    if(jcxw==-1){
                        if(jczw==-1){
                            st=jcsw;
                        }else{
                            st=jczw;
                        }
                    }else{
                        st=jcxw;
                    }
                    for(var i=st+1;i<=jcws;i++){
                        num+="晚上第"+(parseInt(sksj2[i].substring(2,4),10)-sw-zw-xw)+",";
                    }
                }
                num=num.substring(0,num.length-1);
                return week+num+"节课";
            },
        }
    };
</script>
<style src="styles/mobile.css"></style>
<style scoped>
    #mobileMode #queryArea {
        height: 40px;
        margin: 10px 0 10px 0;
    }

    #mobileMode #queryDialog {
        top: 150px;
    }

    #mobileMode #mainDialogScroll {
        height: 65vh;
        padding: 10px 20px;
    }

    #mobileMode #listArea {
        height: calc(100% - 140px);
    }

    #mobileMode #loadingTips {
        height: 30px;
        line-height: 30px;
        color: #9d9d9d;
        position: relative;
        bottom: 0;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// electiveSelection.vue?cf6113da